import axios from "axios"
import {
    addressListRequest,
    addressListSuccess,
    addressListFail,

    addressUpdateRequest,
    addressUpdateSuccess,
    addressUpdateFail,

    addressCreateRequest,
    addressCreateSuccess,
    addressCreateFail,
    
    addressDeleteRequest,
    addressDeleteSuccess,
    addressDeleteFail,
    addressDetailRequest,
    addressDetailSuccess,
    addressDetailFail,
} from '../reducers/addressReducers'

// Function to get CSRF token from cookie
const getCsrfToken = () => {
    const name = 'csrftoken';
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

const createAPIinstance = () => {
    const csrfToken = getCsrfToken();
    const token = localStorage.getItem('accessToken');
    
    // Debug logging
    console.log('CSRF Token:', csrfToken);
    console.log('Access Token:', token);
    
    // Define the URL for address-related API requests
    const baseURL = `${process.env.REACT_APP_BASE_API_URL}/api/addresses`;
    
    // Include CSRF token and Authorization token in headers
    const headers = {
        'Content-Type': 'application/json',
    };
    
    if (csrfToken) {
        headers['X-CSRFToken'] = csrfToken;
    }
    
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    } 
        
    const instance = axios.create({
        baseURL: baseURL,
        headers: headers,
        withCredentials: true // This ensures cookies are sent with the request
    });

    return instance;
}

// First fetch CSRF token before any address operations
export const fetchCsrfToken = () => async () => {
    try {
        // Make a request to a CSRF endpoint to get a fresh token
        await axios.get(`${process.env.REACT_APP_BASE_API_URL}/api/users/csrf/`, {
            withCredentials: true
        });
        return true;
    } catch (error) {
        return false;
    }
};

export const listAddresses = () => async (dispatch) => {
    try {
        // First fetch a fresh CSRF token
        await dispatch(fetchCsrfToken());
        
        dispatch(addressListRequest())

        // Debug log
        console.log('Fetching addresses...');

        const api = createAPIinstance()
        const { data } = await api.get('/');
        
        // Debug logging
        console.log('Address API response:', data);
        
        const addresses = Array.isArray(data) ? data : 
                        data && data.results ? data.results :
                        data ? [data] : [];
        
        // Debug logging
        console.log('Processed addresses:', addresses);
        
        dispatch(addressListSuccess(addresses))
    } catch(error) {
        // Enhanced error logging
        console.error('Error fetching addresses:', error);
        console.error('Error response:', error.response);
        
        dispatch(addressListFail(
            error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ))
    }
}

export const createAddress = (address) => async (dispatch) => {
    try {
        // First fetch a fresh CSRF token
        await dispatch(fetchCsrfToken());
        
        dispatch(addressCreateRequest())
        
        const api = createAPIinstance()
        const { data } = await api.post(
            '/',
            address
        );
        
        // Ensure we have a valid address object to return
        const addressData = data.results ? data.results[0] : data;
        
        dispatch(addressCreateSuccess(addressData))
    } catch(error) {
        dispatch(addressCreateFail(
            error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message
        ))
    }
}

export const updateAddress = (address) => async (dispatch) => {
    try {
        // First fetch a fresh CSRF token
        await dispatch(fetchCsrfToken());
        
        dispatch(addressUpdateRequest())
      
        const api = createAPIinstance()
        const { data } = await api.put(
            `/${address._id}/`,
            address
        ).catch(error => {
            console.error('Update request failed:', error.response || error);
            throw error;
        });

                await dispatch(addressUpdateSuccess(data))
        dispatch(listAddresses())
    } catch(error) {
        console.error('Update address error:', error);
        const errorMessage = error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message;
        console.error('Error message:', errorMessage);
        dispatch(addressUpdateFail(errorMessage));
    }
}

export const deleteAddress = (id) => async (dispatch) => {
    try {
        // First fetch a fresh CSRF token
        await dispatch(fetchCsrfToken());
        
        dispatch(addressDeleteRequest())
        
        const api = createAPIinstance()
              
        const { data } = await api.delete(`/${id}/`).catch(error => {
            throw error;
        });

        await dispatch(addressDeleteSuccess(data))
       
        dispatch(listAddresses())
    } catch(error) {
        console.error('Delete address error:', error);
        const errorMessage = error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message;
        console.error('Error message:', errorMessage);
        dispatch(addressDeleteFail(errorMessage));
    }
}

export const addressDetail = (id) => async (dispatch) => {
    try {
        // First fetch a fresh CSRF token
        await dispatch(fetchCsrfToken());
        
        dispatch(addressDetailRequest())

        const api = createAPIinstance()
        const { data } = await api.get(`/${id}`)
        
        dispatch(addressDetailSuccess(data))
    } catch (error) {
        dispatch(addressDetailFail(error.response && error.response.data.detail ?
            error.response.data.detail :
            error.message
        ))
    }
}